/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FormFieldValidationModel } from './FormFieldValidationModel';
import {
    FormFieldValidationModelFromJSON,
    FormFieldValidationModelFromJSONTyped,
    FormFieldValidationModelToJSON,
} from './FormFieldValidationModel';

/**
 * 
 * @export
 * @interface FormFieldConfigModel
 */
export interface FormFieldConfigModel {
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldConfigModel
     */
    isRequired: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldConfigModel
     */
    isEditable: boolean;
    /**
     * 
     * @type {FormFieldValidationModel}
     * @memberof FormFieldConfigModel
     */
    validation?: FormFieldValidationModel;
}

/**
 * Check if a given object implements the FormFieldConfigModel interface.
 */
export function instanceOfFormFieldConfigModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isRequired" in value;
    isInstance = isInstance && "isEditable" in value;

    return isInstance;
}

export function FormFieldConfigModelFromJSON(json: any): FormFieldConfigModel {
    return FormFieldConfigModelFromJSONTyped(json, false);
}

export function FormFieldConfigModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormFieldConfigModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isRequired': json['isRequired'],
        'isEditable': json['isEditable'],
        'validation': !exists(json, 'validation') ? undefined : FormFieldValidationModelFromJSON(json['validation']),
    };
}

export function FormFieldConfigModelToJSON(value?: FormFieldConfigModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isRequired': value.isRequired,
        'isEditable': value.isEditable,
        'validation': FormFieldValidationModelToJSON(value.validation),
    };
}

